(function () {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Guest', Guest);

    /* @ngInject */
    function Guest($http) {
        var host = window.location.href.split('/')[2];
        var bearerToken = null;
        var userId = null;
        // Drop workspace label: master.atheer.qa → atheer.qa; master.demo.atheer.qa → demo.atheer.qa
        var baseDomain = host.startsWith('localhost')
            ? 'atheer.dev'
            : host.split('.').slice(1).join('.');
        var service = {
            createGuestUser: createGuestUser,
            validateWorkspaceCode: validateWorkspaceCode,
            updateGuestUser: updateGuestUser,
            getSessionDetails: getSessionDetails,
            setBearerToken: setBearerToken,
            getBearerToken: getBearerToken,
            setGuestUserId: setGuestUserId,
            getGuestUserId: getGuestUserId
        };
        return service;

        function createGuestUser(data, workspace) {
            return $http.post('https://' + workspace + '.' + baseDomain + '/api/users/guest', data);
        };

        function validateWorkspaceCode(code, workspace) {
            return $http.get('https://' + workspace + '.' + baseDomain + '/api/system/settings/workspace/info/code/' + code);
        };

        function updateGuestUser(userId, workspace, data) {
            return $http({
                method: 'POST',
                url: 'https://' + workspace + '.' + baseDomain + '/api/users/guest/update/' + userId,
                data: data
            });
        };

        function getSessionDetails(userId, roomNo, workspace) {
            return $http({
                method: 'GET',
                url: 'https://' + workspace + '.' + baseDomain + '/api/sessions/guest/session/' + userId + '/' + roomNo
            });
        };

        function setBearerToken(token) {
            bearerToken = token;
        };

        function getBearerToken() {
            return bearerToken;
        };

        function setGuestUserId(id) {
            userId = id;
        };

        function getGuestUserId() {
            return userId;
        };
    }
})();